// InfoModal.js
import React from 'react';

const InfoModal = ({ isOpen, onClose, title, children }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-100 flex items-center justify-center bg-black bg-opacity-50">
      <div className="w-full max-w-4xl h-2/3 flex flex-col bg-white rounded-lg overflow-hidden">
        <div className="flex justify-between items-center p-4 pb-3 border-b-2 flex-shrink-0 bg-white">
          <h2 className="text-sm sm:text-lg font-semibold truncate pr-4">{title}</h2>
          <button onClick={onClose} className="flex text-xl font-semibold flex-shrink-0" aria-label="Close">
            &times;
          </button>
        </div>
        <div className="flex-1 min-h-0 overflow-y-auto p-4 pt-3">
          {children}
        </div>
      </div>
    </div>
  );
};

export default InfoModal;
